<app-header></app-header>
<!--div class="container-fluid" style="display: flex; flex-direction: row;"-->
<div style="display: flex; flex-direction: row;">
  <div class="content" style="flex: 1;">
    <router-outlet />
  </div>
</div>
<app-footer style="bottom: 0px;"></app-footer>
<!--router-outlet></router-outlet-->
